import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, AppBar, Toolbar, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import CloseIcon from '@material-ui/icons/Close';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";
import Select from 'react-select';

import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert';

const styles = theme => ({
    layoutRoot: {},

});

class Supplier extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            open: false,
            data: [],
            rowId: 0,

            loadSuppliers: [],
            loadCountryList: [],
            supplierCountry: '',
            postalCountry: '',
            billingCountry: '',
            loadTitleTypes: [],
            supplierTypes: [],

            contactPersonDetailsAr: [],

            contactPersonTitle: '',
            contactPersonName: '',
            contactPersonDesignation: '',
            contactPersonMobile: '',
            contactPersonTelephone: '',
            contactPersonFax: '',
            contactPersonEmail: '',


            editSupplierProfileId: '',
            editSupplierRegistryId: '',
            editSupplierBillingId: '',
            editSupplierPostalId: '',
            editSupplierTypeId: '',
            editSupplierCode: '',
            editSupplierRefNo: '',
            editSupplierTitle: '',
            editSupplierName: '',
            editSupplierGST: '',
            editSupplierEmail: '',
            editSupplierCountry: '',
            editSupplierWebsite: '',
            ///
            editPostalAddress: '',
            editPostalCountry: '',
            editPostalState: '',
            editPostalCity: '',
            editPostalZipCode: '',


            editBillingAddress: '',
            editBillingCountry: '',
            editBillingState: '',
            editBillingCity: '',
            editBillingZipCode: '',

            editContactPersonDetailsAr: [],
            editContactPersonRowId: 0,
        };

        this.loadAllSuppliers();
        this.loadEmployeeTitleTypes();
        this.loadAllCountries();
        this.loadSupplierTypes();

        this.getContactPersonTitle = this.getContactPersonTitle.bind(this);
    }

    getContactPersonTitle = (selectedOption) => {
        if (null == selectedOption) {
            this.setState({ contactPersonTitle: '' });
        } else {
            this.setState({ contactPersonTitle: selectedOption.value });
            this.setState({ editContactPersonTitle: selectedOption.value });
        }
    }
    // Add Statement

    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
        this.setState({ edit: false })
    };


    state = {
        canSubmit: false
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };


    onEdit = (model) => {
        this.updateSupplier(model);
    };

    addToTable = (model) => {

        if (null == this.state.contactPersonName || '' == this.state.contactPersonName || undefined == this.state.contactPersonName
            || null == this.state.contactPersonMobile || '' == this.state.contactPersonMobile || undefined == this.state.contactPersonMobile) {
            this.props.alert.error("Input Contact Person Name and Mobile No first");

        } else {
            this.state.rowId = this.state.rowId + 1;

            var contactPersonDetailObj = {
                rowId: this.state.rowId,
                contactPersonTitle: this.state.contactPersonTitle,
                contactPersonName: this.state.contactPersonName,
                contactPersonDesignation: this.state.contactPersonDesignation,
                contactPersonMobile: this.state.contactPersonMobile,
                contactPersonTelephone: this.state.contactPersonTelephone,
                contactPersonFax: this.state.contactPersonFax,
                contactPersonEmail: this.state.contactPersonEmail,
            };

            this.setState(prevState => ({
                contactPersonDetailsAr: [...prevState.contactPersonDetailsAr, contactPersonDetailObj]
            }));
        }

        // clear contact person fields
        this.setState({
            contactPersonTitle: '',
            contactPersonName: '',
            contactPersonDesignation: '',
            contactPersonMobile: '',
            contactPersonTelephone: '',
            contactPersonFax: '',
            contactPersonEmail: '',
        });
    }

    //add edit supplier contact person into table
    addToEditTable = (model) => {

        if (null == this.state.editContactPersonName || '' == this.state.editContactPersonName || undefined == this.state.editContactPersonName
            || null == this.state.editContactPersonMobile || '' == this.state.editContactPersonMobile || undefined == this.state.editContactPersonMobile) {
            this.props.alert.error("Input Contact Person Name and Mobile No first");

        } else {

            this.state.editContactPersonRowId = this.state.editContactPersonRowId + 1;

            var contactPersonDetailObj = {
                editRowId: this.state.editContactPersonRowId,
                editContactPersonTitle: this.state.editContactPersonTitle,
                editContactPersonName: this.state.editContactPersonName,
                editContactPersonDesignation: this.state.editContactPersonDesignation,
                editContactPersonMobile: this.state.editContactPersonMobile,
                editContactPersonTelephone: this.state.editContactPersonTelephone,
                editContactPersonFax: this.state.editContactPersonFax,
                editContactPersonEmail: this.state.editContactPersonEmail,
            };

            this.setState(prevState => ({
                editContactPersonDetailsAr: [...prevState.editContactPersonDetailsAr, contactPersonDetailObj]
            }));

            this.setState({
                editContactPersonTitle: '',
                editContactPersonName: '',
                editContactPersonDesignation: '',
                editContactPersonMobile: '',
                editContactPersonTelephone: '',
                editContactPersonFax: '',
                editContactPersonEmail: ''
            });
        }
    }

    loadAllSuppliers() {
        this.setState({ loading: true });
        var loadSuppliers = [];

        axios.get(window.inventoryServer + '/supplier/getAllSuppliers')
            // axios.get('http://localhost:5004/supplier/getAllSuppliers')
            .then(response => {
                if (null == response || undefined == response || 0 == response.data.result.length) {

                    this.props.alert.error("No Suppliers Found !");
                    this.setState({ loading: false });

                } else {
                    for (var i = 0; i < response.data.result.length; i++) {

                        loadSuppliers.push({
                            supplierProfileId: response.data.result[i].ID_SUPPLIER_PROFILE,
                            supplierRegistryId: response.data.result[i].ID_SUPPLIER_REGISTRY,
                            supplierBillingId: response.data.result[i].ID_BILLING_DETAIL,
                            supplierPostalId: response.data.result[i].ID_POSTAL_DETAILS,
                            supplierTypeId: response.data.result[i].ID_SUPPLIER_TYPE,
                            supplierCode: response.data.result[i].SUPPLIER_CODE,
                            supplierRefNo: response.data.result[i].REF_NO,
                            supplierTitle: response.data.result[i].TITLE,
                            supplierName: response.data.result[i].SUPPLIER_NAME,
                            supplierGST: response.data.result[i].GST_NO,
                            supplierEmail: response.data.result[i].EMAIL,
                            supplierCountry: response.data.result[i].COUNTRY,
                            supplierWebsite: response.data.result[i].WEBSITE,
                            supplierActive: response.data.result[i].IS_ACTIVE,
                            supplierStatus: response.data.result[i].STATUS
                        });
                    }
                    this.setState({
                        loadSuppliers: loadSuppliers,
                        loading: false
                    });
                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    // Delete Statement

    handleClickDelete = () => {
        // alert(e.value);
        this.setState({ delete: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    handleClickActive = () => {
        // alert(e.value);
        this.setState({ active: true });
    };

    handleCloseActive = () => {
        this.setState({ active: false });
    };

    stateDelete = {
        canDelete: false
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    onDelete = (supplierId) => {

        this.deactivateSupplier(supplierId);
    };

    onActive = (supplierId) => {

        this.activateSupplier(supplierId);
    };

    // deactive supplier
    deactivateSupplier(supplierId) {
        this.setState({ loading: true });

        if (null == supplierId || "" == supplierId || undefined == supplierId) {

            this.props.alert.error("Cannot Inactive Supplier !");
            this.setState({ loading: false });

        } else {

            var inactiveObj = {
                supplierId: supplierId
            }

            axios.post(window.inventoryServer + '/supplier/deactiveSupplier', inactiveObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Supplier Deactivated Successfully");
                        this.handleCloseDelete();
                        this.loadAllSuppliers();
                        this.setState({ loading: false });

                    } else {

                        this.props.alert.error("Unable to Inactivated Please Check !");
                        this.setState({ loading: false });

                    }

                }).catch(function (error) {

                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error !");
                    this.setState({ loading: false });

                });
        }
    }

    // active supplier
    activateSupplier(supplierId) {
        this.setState({ loading: true });

        if (null == supplierId || "" == supplierId || undefined == supplierId) {

            this.props.alert.error("Cannot Active Supplier !");
            this.setState({ loading: false });

        } else {

            var activeObj = {
                supplierId: supplierId
            }

            axios.post(window.inventoryServer + '/supplier/activeSupplier', activeObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Supplier Activated Successfully");
                        this.handleCloseActive();
                        this.loadAllSuppliers();
                        this.setState({ loading: false });

                    } else {

                        this.props.alert.error("Unable to Activated Please Check !");
                        this.setState({ loading: false });

                    }

                }).catch(function (error) {

                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error !");
                    this.setState({ loading: false });

                });
        }
    }


    // set supplier area country
    handleSupplierCountryChange = (selectedOption) => {
        if (null == selectedOption) {

            this.setState({ supplierCountry: '' });
            this.setState({ editSupplierCountry: '' });

        } else {
            // this.setState({ supplierCountry: selectedOption });
            this.setState({ editSupplierCountry: selectedOption });
        }
    }


    // set postal area country
    handlePostalCountryChange = (selectedOption) => {
        if (null == selectedOption) {
            this.setState({
                postalCountry: '',
                editPostalCountry: ''
            });
        } else {
            this.setState({
                postalCountry: selectedOption,
                editPostalCountry: selectedOption
            });
        }
    }

    // set billing area country
    handleBillingCountryChange = (selectedOption) => {
        if (null == selectedOption) {
            this.setState({ billingCountry: '' });
            this.setState({ editBillingCountry: '' });
        } else {
            this.setState({ billingCountry: selectedOption });
            this.setState({ editBillingCountry: selectedOption });
        }
    }

    // set supplier contact person fields data to state
    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    // load country list into drop-down
    loadAllCountries() {
        var loadCountryList = [];

        axios.get('https://restcountries.eu/rest/v2/all')
            .then(response => {
                // console.log();
                for (let i = 0; i < response.data.length; i++) {

                    loadCountryList.push({
                        value: response.data[i].name,
                        label: response.data[i].name
                    });
                }

            }).catch(function (error) {
                console.log("err " + error);
                // alert("No internet connection or Internal error");
            });
        var c = { country: loadCountryList };
        // this.setState({loadCountryList : loadCountryList});
        return c;
    }

    // load supplier title into drop-down
    loadEmployeeTitleTypes() {
        this.setState({ loading: true });
        var loadTitleTypes = [];

        axios.get(window.systemServer + '/system/loadTitle')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadTitleTypes.push({
                            value: response.data.result[i].title,
                            label: response.data.result[i].title
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {
                        loadTitleTypes.push({
                            value: response.data[i].title,
                            label: response.data[i].title
                        });
                    }
                this.setState({ loadTitleTypes: loadTitleTypes });
                this.setState({ loading: false });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }


    // load supplier types into drop-down
    loadSupplierTypes() {
        this.setState({ loading: true });
        var loadSupplierTypes = [];

        axios.get(window.inventoryServer + '/supplier/getSupplierTypes')
            // axios.get('http://localhost:5004/supplier/getSupplierTypes')
            .then(response => {
                console.log("response.data.result.length ", response.data.result.length);
                if (null == response || undefined == response || 0 == response.data.result.length) {

                } else {
                    for (let i = 0; i < response.data.result.length; i++) {
                        loadSupplierTypes.push({
                            value: response.data.result[i].ID_SUPPLIER_TYPE,
                            label: response.data.result[i].TYPE
                        });
                    }
                    this.setState({ supplierTypes: loadSupplierTypes });
                    this.setState({ loading: false });
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.setState({ loading: false });
            });
    }

    // update supplier 
    updateSupplier(model) {
        this.setState({ loading: true });
        // get supplier edit postal details

        var postalCountry = '';
        if (null == this.state.editPostalCountry || '' == this.state.editPostalCountry || undefined == this.state.editPostalCountry) {
            postalCountry = '';
        } else {
            postalCountry = this.state.editPostalCountry.value;
        }

        var postalDetails = {
            postalAddress: model.editPostalAddress,
            postalCountry: postalCountry,
            postalState: model.editPostalState,
            postalCity: model.editPostalCity,
            postalZipCode: model.editPostalZipCode
        };

        // get supplier billing details
        var billingCountry = '';
        if (null == this.state.editBillingCountry || '' == this.state.editBillingCountry || undefined == this.state.editBillingCountry) {
            billingCountry = '';
        } else {
            billingCountry = this.state.editBillingCountry.value;
        }
        var billingDetails = {
            billingAddress: model.editBillingAddress,
            billingCountry: billingCountry,
            billingState: model.editBillingState,
            billingCity: model.editBillingCity,
            billingZipCode: model.editBillingZipCode
        };

        // get supplier profile details
        var supplierCountry = '';
        if (null == this.state.editSupplierCountry || '' == this.state.editSupplierCountry || undefined == this.state.editSupplierCountry) {
            supplierCountry = '';
        } else {
            supplierCountry = this.state.editSupplierCountry.value;
        }

        var profileDetails = {
            supplierProfileId: this.state.editSupplierProfileId,
            supplierRegistryId: this.state.editSupplierRegistryId,
            supplierType: model.editSupplierType,
            supplierCode: model.editSupplierCode,
            refNo: model.editRefNo,
            title: model.editTitle,
            supplierName: model.editSupplierName,
            gstNo: model.editGstNo,
            email: model.editEmail,
            supplierCountry: supplierCountry,
            webSite: model.editWebSite,
        };

        // get supplier contact person details
        var contactPersonDetails = this.state.editContactPersonDetailsAr;

        var supplierObj = {
            postalDetails: postalDetails,
            billingDetails: billingDetails,
            profileDetails: profileDetails,
            contactPersonDetails: contactPersonDetails
        }

        if (null == model.editSupplierName || "" == model.editSupplierName || undefined == model.editSupplierName) {
            this.props.alert.error("Input all requid fields ");
            this.setState({ loading: false });
        } else {
            axios.post(window.inventoryServer + '/supplier/updateSupplier', supplierObj)
                // axios.post('http://localhost:5004/supplier/updateSupplier', supplierObj)

                .then(response => {
                    if (response.data.success) {

                        this.props.alert.success("Supplier Updated Successfully");
                        this.addhandleClose();
                        this.state.editContactPersonDetailsAr = [];
                        this.loadAllSuppliers();
                        this.setState({ loading: false });

                    } else {
                        this.props.alert.error("Supplier Updated Faild");
                        this.setState({ loading: false });
                    }

                }).catch(function (error) {
                    // alert(error);
                    console.log("server er : ", error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        }
    }

    // remove contact person from table
    removeContactPerson(rowId) {

        var contactPersonAr = this.state.contactPersonDetailsAr;
        var index = contactPersonAr.findIndex(x => x.rowId == rowId);

        contactPersonAr.splice(index, 1);
        this.setState({ contactPersonDetailsAr: contactPersonAr });

    }

    // remove edit contact person from table
    removeEditContactPerson(rowId) {

        var contactPersonAr = this.state.editContactPersonDetailsAr;
        // var index = contactPersonAr.findIndex(x => x.rowId == rowId);

        contactPersonAr.splice(rowId, 1);
        this.setState({ editContactPersonDetailsAr: contactPersonAr });

    }

    //////////////////////////////////////////////edit supplier details load /////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////

    // load supplier postal detail
    loadSupplierPostalDetail(postalId) {
        this.setState({ loading: true });

        if (null == postalId || "" == postalId || undefined == postalId) {
            this.props.alert.error("No Postal details found");
            this.setState({ loading: false });

        } else {

            var postalObj = {
                postalId: postalId
            };

            axios.post(window.inventoryServer + '/supplier/getSupplierPostalDetail', postalObj)

                .then(response => {
                    if (response.data.success) {

                        if (0 == response.data.resultPostalDetail.length || null == response.data.resultPostalDetail || undefined == response.data.resultPostalDetail) {
                            this.setState({ loading: false });

                        } else {

                            this.setState({
                                editPostalAddress: response.data.resultPostalDetail[0].POSTAL_ADDRESS,
                                editPostalCountry: {
                                    value: response.data.resultPostalDetail[0].COUNTRY,
                                    label: response.data.resultPostalDetail[0].COUNTRY
                                },
                                editPostalState: response.data.resultPostalDetail[0].STATE,
                                editPostalCity: response.data.resultPostalDetail[0].CITY,
                                editPostalZipCode: response.data.resultPostalDetail[0].ZIP_CODE,
                                loading: false
                            });
                        }
                    }
                }).catch(function (error) {
                    // alert(error);
                    console.log("server er : ", error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        }
    }

    // load supplier billing detail
    loadSupplierBillingDetail(billingId) {
        this.setState({ loading: true });

        if (null == billingId || "" == billingId || undefined == billingId) {
            this.props.alert.error("No billing details found");
            this.setState({ loading: false });

        } else {

            var billingObj = {
                billingId: billingId
            };

            axios.post(window.inventoryServer + '/supplier/getSupplierBillingDetail', billingObj)

                .then(response => {
                    if (response.data.success) {

                        if (0 == response.data.resultBillingDetail.length || null == response.data.resultBillingDetail || undefined == response.data.resultBillingDetail) {
                            this.setState({ loading: false });

                        } else {

                            this.setState({
                                editBillingAddress: response.data.resultBillingDetail[0].BILLING_ADDRESS,
                                editBillingCountry: {
                                    value: response.data.resultBillingDetail[0].COUNTRY,
                                    label: response.data.resultBillingDetail[0].COUNTRY
                                },
                                editBillingState: response.data.resultBillingDetail[0].STATE,
                                editBillingCity: response.data.resultBillingDetail[0].CITY,
                                ditBillingZipCode: response.data.resultBillingDetail[0].ZIP_CODE,
                                loading: false
                            });
                        }
                    }
                }).catch(function (error) {
                    // alert(error);
                    console.log("server er : ", error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        }
    }

    // load supplier contact person details
    loadSupplierContactPersonDetails(supplierId) {
        this.setState({ loading: true });

        if (null == supplierId || "" == supplierId || undefined == supplierId) {
            this.props.alert.error("Cannot get Supplier Id");
            this.setState({ loading: false });

        } else {

            var supplierObj = {
                supplierId: supplierId
            };

            axios.post(window.inventoryServer + '/supplier/getSupplierContactPersonDetail', supplierObj)
                // axios.post('http://localhost:5004/supplier/getSupplierContactPersonDetail', supplierObj)

                .then(response => {
                    console.log("response.data.resultContactPersonDetail.length ", response.data.resultContactPersonDetail.length);
                    if (response.data.success) {
                        if (0 == response.data.resultContactPersonDetail.length || null == response.data.resultContactPersonDetail || undefined == response.data.resultContactPersonDetail) {
                            this.setState({ loading: false });

                        } else {

                            var editSupplierContactDetail = [];
                            this.setState({ editContactPersonRowId: response.data.resultContactPersonDetail.length })
                            for (var i = 0; i < response.data.resultContactPersonDetail.length; i++) {

                                editSupplierContactDetail.push({
                                    editRowId: i,
                                    editContactPersonTitle: response.data.resultContactPersonDetail[i].TITLE,
                                    editContactPersonName: response.data.resultContactPersonDetail[i].CONTACT_PERSON_NAME,
                                    editContactPersonDesignation: response.data.resultContactPersonDetail[i].DESIGNATION,
                                    editContactPersonMobile: response.data.resultContactPersonDetail[i].MOBILE,
                                    editContactPersonTelephone: response.data.resultContactPersonDetail[i].TELEPHONE,
                                    editContactPersonFax: response.data.resultContactPersonDetail[i].FAX,
                                    editContactPersonEmail: response.data.resultContactPersonDetail[i].EMAIL,
                                });
                            }

                            this.setState({ editContactPersonDetailsAr: editSupplierContactDetail });
                            this.setState({ loading: false });
                        }
                    }
                }).catch(function (error) {
                    // alert(error);
                    console.log("server er : ", error);
                    console.log("No internet connection or Internal error");
                    this.setState({ loading: false });
                });
        }
    }


    // edit contact person details
    editContactPerson(id) {
        var contactDetailAr = this.state.editContactPersonDetailsAr;

        if (contactDetailAr.length > 0) {
            this.setState({
                editContactPersonTitle: contactDetailAr[id].editContactPersonTitle,
                editContactPersonName: contactDetailAr[id].editContactPersonName,
                editContactPersonDesignation: contactDetailAr[id].editContactPersonDesignation,
                editContactPersonMobile: contactDetailAr[id].editContactPersonMobile,
                editContactPersonTelephone: contactDetailAr[id].editContactPersonTelephone,
                editContactPersonFax: contactDetailAr[id].editContactPersonFax,
                editContactPersonEmail: contactDetailAr[id].editContactPersonEmail,
            });

            var index = contactDetailAr.findIndex(x => x.id == id);

            contactDetailAr.splice(index, 1);
            this.setState({ editContactPersonDetailsAr: contactDetailAr });
        } else {
            console.log('No contact person details for edting...')
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <Loader />
            );
        } else {
            const { openEditContactDialog } = this.props;
            const { canSubmit } = this.state;
            const { canEdit } = this.stateEdit;
            const { canDelete } = this.stateDelete;
            const { classes } = this.props;
            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}

                    contentToolbar={
                        <div className="px-24"><h2 className="subtitle-color">All Suppliers</h2></div>
                    }


                    content={
                        <div class="flex h-auto ">

                            <div class="w-full bg-white h-auto m-4">
                                <ReactTable className="w-full"
                                    getTrProps={(state, rowInfo, column) => {
                                        return {
                                            className: "cursor-pointer",
                                            onClick: (e, handleOriginal) => {

                                            }
                                        }
                                    }}
                                    data={this.state.loadSuppliers}
                                    columns={[

                                        {
                                            Header: "id",
                                            accessor: "supplierProfileId",
                                            show: false
                                        },
                                        {
                                            Header: "id",
                                            accessor: "supplierRegistryId",
                                            show: false
                                        },
                                        {
                                            Header: "id",
                                            accessor: "supplierBillingId",
                                            show: false
                                        },
                                        {
                                            Header: "id",
                                            accessor: "supplierPostalId",
                                            show: false
                                        },
                                        {
                                            Header: "id",
                                            accessor: "supplierTypeId",
                                            show: false
                                        },
                                        {
                                            Header: "Code",
                                            accessor: "supplierCode",
                                            filterable: true
                                        },
                                        {
                                            Header: "Ref No",
                                            accessor: "supplierRefNo",
                                            filterable: true
                                        },

                                        {
                                            Header: "Title",
                                            accessor: "supplierTitle",
                                            filterable: true
                                        },

                                        {
                                            Header: "Name",
                                            accessor: "supplierName",
                                            filterable: true
                                        },
                                        {
                                            Header: "GST",
                                            accessor: "supplierGST",
                                            filterable: true
                                        },
                                        {
                                            Header: "Email",
                                            accessor: "supplierEmail",
                                            filterable: true

                                        },
                                        {
                                            Header: "Country",
                                            accessor: "supplierCountry",
                                            filterable: true

                                        },
                                        {
                                            Header: "Web Site",
                                            accessor: "supplierWebsite",
                                            filterable: true

                                        },
                                        {
                                            Header: "active",
                                            accessor: "supplierStatus",
                                            show: false

                                        },

                                        {
                                            Header: "Action",
                                            // accessor: "su",
                                            width: 128,
                                            Cell: row => (

                                                row.original.supplierStatus == 1 ? (
                                                    <div className="flex items-center">

                                                        <Tooltip
                                                            enterDelay={300}
                                                            id="tooltip-controlled"
                                                            leaveDelay={300}
                                                            placement="bottom"
                                                            title="Do you want to inactive ?"
                                                        >
                                                            <IconButton
                                                                className={classes.smaller}
                                                                onClick={(e) => {
                                                                    if (row) {

                                                                        var supplierProId = row.original.supplierProfileId;

                                                                        this.setState({ delete: true });

                                                                        confirmAlert({
                                                                            title: 'Confirm to Deactivate',
                                                                            message: 'Are you sure to do this.',
                                                                            buttons: [
                                                                                {
                                                                                    label: 'Yes',
                                                                                    onClick: () => this.onDelete(supplierProId)
                                                                                },
                                                                                {
                                                                                    label: 'No'
                                                                                }
                                                                            ]
                                                                        })
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-green">check_circle</Icon>
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Tooltip
                                                            enterDelay={300}
                                                            id="tooltip-controlled"
                                                            leaveDelay={300}
                                                            placement="bottom"
                                                            title="Do you want to Edit ?"
                                                        >
                                                            <IconButton
                                                                className={classes.smaller}

                                                                onClick={(e) => {
                                                                    if (row) {

                                                                        this.setState({
                                                                            editSupplierProfileId: row.original.supplierProfileId,
                                                                            editSupplierRegistryId: row.original.supplierRegistryId,
                                                                            editSupplierBillingId: row.original.supplierBillingId,
                                                                            editSupplierPostalId: row.original.supplierPostalId,
                                                                            editSupplierTypeId: row.original.supplierTypeId,
                                                                            editSupplierCode: row.original.supplierCode,
                                                                            editSupplierRefNo: row.original.supplierRefNo,
                                                                            editSupplierTitle: row.original.supplierTitle,
                                                                            editSupplierName: row.original.supplierName,
                                                                            editSupplierGST: row.original.supplierGST,
                                                                            editSupplierEmail: row.original.supplierEmail,
                                                                            editSupplierCountry: {
                                                                                value: row.original.supplierCountry,
                                                                                label: row.original.supplierCountry
                                                                            },
                                                                            editSupplierWebsite: row.original.supplierWebsite,
                                                                            edit: true
                                                                        });

                                                                        // load supplier billing and postal details
                                                                        this.loadSupplierPostalDetail(row.original.supplierPostalId);
                                                                        this.loadSupplierBillingDetail(row.original.supplierBillingId);
                                                                        this.loadSupplierContactPersonDetails(row.original.supplierProfileId);
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-blue">mode_edit</Icon>
                                                            </IconButton>
                                                        </Tooltip>

                                                        <Dialog className={classNames(classes.root, "z-10")} open={this.state.edit} fullWidth maxWidth="md" className="w-full">

                                                            <AppBar className="flex w-full h-56" position="static">
                                                                <Toolbar className="flex w-full">
                                                                    <Typography className="w-full" variant="subheading" color="inherit">
                                                                        Edit Supplier
                                                                    </Typography>
                                                                    <IconButton className="" color="inherit" onClick={this.addhandleClose} aria-label="Close">
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                </Toolbar>
                                                            </AppBar>
                                                            <DialogContent className="edit-supplier-form-margin">
                                                                <div >
                                                                    <Formsy
                                                                        onValidSubmit={this.onEdit}
                                                                        onValid={this.enableButton}
                                                                        onInvalid={this.disableButton}
                                                                        ref={(form) => this.form = form}
                                                                        className="flex flex-col justify-center"
                                                                    >

                                                                        <div className="flex flex-wrap -mx-3 mb-6">
                                                                            <SelectFormsy
                                                                                className="w-full md:w-1/4 pr-24"
                                                                                name="editSupplierType"
                                                                                label=""
                                                                                value={this.state.editSupplierTypeId}
                                                                            >
                                                                                <MenuItem className="popup-value-size" disabled value="none">
                                                                                    <em>Select Type</em>
                                                                                </MenuItem>
                                                                                {this.state.supplierTypes.map(function (item, i) {
                                                                                    return <MenuItem className="popup-value-size" value={item.value}>{item.label}</MenuItem>;
                                                                                })}

                                                                            </SelectFormsy>

                                                                            <TextField
                                                                                className="w-full md:w-1/4  mt-24 pr-24"
                                                                                type="text"
                                                                                name="editSupplierCode"
                                                                                label="SupplierCode"
                                                                                value={this.state.editSupplierCode}
                                                                            />

                                                                            <TextField
                                                                                className="w-full md:w-1/4  mt-24 pr-24"
                                                                                type="text"
                                                                                name="editRefNo"
                                                                                label="Ref No"
                                                                                value={this.state.editSupplierRefNo}
                                                                            />
                                                                        </div>

                                                                        <div className="flex flex-wrap -mx-3 mb-6">
                                                                            <SelectFormsy
                                                                                className="w-full md:w-1/4 mt-16  pr-24"
                                                                                name="editTitle"
                                                                                label=""
                                                                                value={this.state.editSupplierTitle}
                                                                            >
                                                                                <MenuItem className="popup-value-size" disabled value="none">
                                                                                    <em>Select Title</em>
                                                                                </MenuItem>
                                                                                {this.state.loadTitleTypes.map(function (item, i) {
                                                                                    return <MenuItem className="popup-value-size" value={item.value}>{item.value}</MenuItem>;
                                                                                })}

                                                                            </SelectFormsy>

                                                                            <TextFieldFormsy
                                                                                className="w-full md:w-3/4  mt-24 pr-24"
                                                                                type="text"
                                                                                name="editSupplierName"
                                                                                label="Name"
                                                                                value={this.state.editSupplierName}
                                                                            />
                                                                        </div>

                                                                        <div className="flex flex-wrap -mx-3 mb-6">
                                                                            <TextFieldFormsy
                                                                                className="w-full md:w-1/4  mt-24 pr-24"
                                                                                type="text"
                                                                                name="editGstNo"
                                                                                label="GST No"
                                                                                value={this.state.editSupplierGST}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-full md:w-1/4 mt-24 pr-24"
                                                                                type="text"
                                                                                name="editEmail"
                                                                                label="Email"
                                                                                validations="isEmail"
                                                                                validationError="This is not a valid email"
                                                                                value={this.state.editSupplierEmail}
                                                                            />

                                                                            <Select
                                                                                className="w-full md:w-1/4 pt-16 mt-24 pr-24 "
                                                                                name="form-field-name"
                                                                                placeholder="Search Country"
                                                                                value={this.state.editSupplierCountry}
                                                                                onChange={this.handleSupplierCountryChange}
                                                                                options={this.loadAllCountries().country}
                                                                            />

                                                                            <TextFieldFormsy
                                                                                className="w-full md:w-1/4  mt-24 pr-24"
                                                                                type="text"
                                                                                name="editWebSite"
                                                                                label="Web Site"
                                                                                value={this.state.editSupplierWebsite}
                                                                            />

                                                                        </div>

                                                                        <div className="md:w-full mt-12 border-solid border-1 rounded border-grey bg-grey-lightest pr-24 ">

                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin">
                                                                                <Select
                                                                                    className="w-full md:w-1/4 pt-16 mt-16 pr-24 "
                                                                                    name="form-field-name"
                                                                                    placeholder="Search Country"
                                                                                    value={this.state.editPostalCountry}
                                                                                    onChange={this.handlePostalCountryChange}
                                                                                    options={this.loadAllCountries().country}
                                                                                />
                                                                            </div>

                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin edit-supplier-form-margin edit-suplier-form-down-margin">
                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-full"
                                                                                    type="text"
                                                                                    name="editPostalAddress"
                                                                                    label="Postal Address"
                                                                                    value={this.state.editPostalAddress}
                                                                                />

                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editPostalState"
                                                                                    label="State"
                                                                                    value={this.state.editPostalState}
                                                                                />

                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editPostalCity"
                                                                                    label="City"
                                                                                    value={this.state.editPostalCity}
                                                                                />

                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editPostalZipCode"
                                                                                    label="Zip Code"
                                                                                    value={this.state.editPostalZipCode}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="md:w-full mt-12 border-solid border-1 rounded border-grey bg-grey-lightest pr-24 ">

                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin ">
                                                                                <Select
                                                                                    className="w-full md:w-1/4 pt-16 mt-16 pr-24 "
                                                                                    name="form-field-name"
                                                                                    placeholder="Search Country"
                                                                                    value={this.state.editBillingCountry}
                                                                                    onChange={this.handleBillingCountryChange}
                                                                                    options={this.loadAllCountries().country}
                                                                                />
                                                                            </div>

                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin edit-supplier-form-margin edit-suplier-form-down-margin">
                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-full"
                                                                                    type="text"
                                                                                    name="editBillingAddress"
                                                                                    label="Billing Address"
                                                                                    value={this.state.editBillingAddress}
                                                                                />

                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editBillingState"
                                                                                    label="State"
                                                                                    value={this.state.editBillingState}
                                                                                />

                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editBillingCity"
                                                                                    label="City"
                                                                                    value={this.state.editBillingCity}
                                                                                />

                                                                                <TextFieldFormsy
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editBillingZipCode"
                                                                                    label="Zip Code"
                                                                                    value={this.state.editBillingZipCode}
                                                                                />
                                                                            </div>

                                                                        </div>

                                                                        <div className="md:w-full mt-12 border-solid border-1 rounded border-grey bg-grey-lightest pr-24 ">
                                                                            <h3 className="edit-supplier-sub-hedding" >Contact Person</h3>
                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin">
                                                                                <Select
                                                                                    className="w-full md:w-1/4 mt-24 pr-24"
                                                                                    name="form-field-name"
                                                                                    placeholder="Select Title"
                                                                                    value={this.state.editContactPersonTitle}
                                                                                    onChange={this.getContactPersonTitle}
                                                                                    options={this.state.loadTitleTypes}
                                                                                />

                                                                            </div>

                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin">
                                                                                <TextField
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editContactPersonName"
                                                                                    label="Name"
                                                                                    value={this.state.editContactPersonName}
                                                                                    onChange={this.handleTextBoxChange('editContactPersonName')}
                                                                                />




                                                                                <TextField
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editContactPersonDesignation"
                                                                                    label="Designation"
                                                                                    value={this.state.editContactPersonDesignation}
                                                                                    onChange={this.handleTextBoxChange('editContactPersonDesignation')}
                                                                                />

                                                                                <TextField
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editContactPersonMobile"
                                                                                    label="Mobile"
                                                                                    value={this.state.editContactPersonMobile}
                                                                                    onChange={this.handleTextBoxChange('editContactPersonMobile')}
                                                                                />

                                                                                <TextField
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editContactPersonTelephone"
                                                                                    label="Telephone"
                                                                                    value={this.state.editContactPersonTelephone}
                                                                                    onChange={this.handleTextBoxChange('editContactPersonTelephone')}
                                                                                />

                                                                            </div>



                                                                            <div className="flex flex-wrap -mx-3 mb-6 supplier-feild-margin">
                                                                                <TextField
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editContactPersonFax"
                                                                                    label="Fax"
                                                                                    value={this.state.editContactPersonFax}
                                                                                    onChange={this.handleTextBoxChange('editContactPersonFax')}
                                                                                />

                                                                                <TextField
                                                                                    className="w-full md:w-1/4  mt-24 pr-24"
                                                                                    type="text"
                                                                                    name="editContactPersonEmail"
                                                                                    label="Email"
                                                                                    validations="isEmail"
                                                                                    validationError="This is not a valid email"
                                                                                    value={this.state.editContactPersonEmail}
                                                                                    onChange={this.handleTextBoxChange('editContactPersonEmail')}
                                                                                />
                                                                            </div>

                                                                            <div className="edit-supplier-button-margin flex flex-wrap -mx-3 mb-6">
                                                                                <div className="mt-16">

                                                                                    <Button type="button" onClick={(e) => this.addToEditTable()} className="mx-16 mt-16 pb-15" variant="raised" color="secondary">
                                                                                        Add
                                                                                    </Button>
                                                                                </div>
                                                                            </div>

                                                                            <ReactTable className=" w-full"
                                                                                getTrProps={(state, rowInfo, column) => {
                                                                                    return {
                                                                                        className: "cursor-pointer",
                                                                                        onClick: (e, handleOriginal) => {
                                                                                            this.editContactPerson(rowInfo.original.editRowId);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                data={this.state.editContactPersonDetailsAr}
                                                                                columns={[

                                                                                    {
                                                                                        Header: "editRowId",
                                                                                        accessor: "editRowId",
                                                                                        show: false
                                                                                    },

                                                                                    {
                                                                                        Header: "Name",
                                                                                        accessor: "editContactPersonName",
                                                                                        filterable: true
                                                                                    },

                                                                                    {
                                                                                        Header: "Designation",
                                                                                        accessor: "editContactPersonDesignation",
                                                                                        filterable: true
                                                                                    },

                                                                                    {
                                                                                        Header: "Mobile",
                                                                                        accessor: "editContactPersonMobile",
                                                                                        filterable: true
                                                                                    },
                                                                                    {
                                                                                        Header: "Telephone",
                                                                                        accessor: "editContactPersonTelephone",
                                                                                        filterable: true
                                                                                    },
                                                                                    {
                                                                                        Header: "Fax",
                                                                                        accessor: "editContactPersonFax",
                                                                                        filterable: true

                                                                                    },
                                                                                    {
                                                                                        Header: "Email",
                                                                                        accessor: "editContactPersonEmail",
                                                                                        filterable: true

                                                                                    },

                                                                                    {
                                                                                        Header: "Action",
                                                                                        // accessor: "su",
                                                                                        width: 128,
                                                                                        Cell: row => (
                                                                                            <div className="flex items-center w-8 h-8">
                                                                                                <Tooltip
                                                                                                    enterDelay={300}
                                                                                                    id="tooltip-controlled"
                                                                                                    leaveDelay={300}
                                                                                                    onClose={this.handleTooltipClose}
                                                                                                    onOpen={this.handleTooltipOpen}
                                                                                                    open={this.state.open}
                                                                                                    placement="bottom"
                                                                                                    title="Remove Contact Preson"
                                                                                                >
                                                                                                    <IconButton
                                                                                                        onClick={(e) => {
                                                                                                            if (row) {

                                                                                                                this.removeEditContactPerson(row.original.editRowId);

                                                                                                            }
                                                                                                        }}

                                                                                                    >
                                                                                                        <Icon className="text-red">cancel</Icon>
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            </div>

                                                                                        )
                                                                                    }

                                                                                ]}
                                                                                defaultPageSize={5}
                                                                                className="-striped -highlight"
                                                                            />
                                                                        </div>

                                                                        <DialogActions className=" justify-right pl-16  ">
                                                                            <div className="mt-16">
                                                                                <Button
                                                                                    type="submit"
                                                                                    variant="raised"
                                                                                    color="secondary"
                                                                                    className="mx-16 mt-16 pb-15"
                                                                                    aria-label="Save"
                                                                                    disabled={!canSubmit}
                                                                                >
                                                                                    Update
                                                                                </Button>
                                                                                <Button className="mx-16 mt-16 pb-15" variant="raised" onClick={this.addhandleClose} color="primary">
                                                                                    Cancel
                                                                                </Button>
                                                                            </div>
                                                                        </DialogActions >

                                                                    </Formsy>


                                                                </div>
                                                            </DialogContent>
                                                        </Dialog>

                                                    </div>

                                                ) : (
                                                    <div className="flex items-center">
                                                        <Tooltip
                                                            enterDelay={300}
                                                            id="tooltip-controlled"
                                                            leaveDelay={300}
                                                            placement="bottom"
                                                            title="Do you want to Active ?"
                                                        >
                                                            <IconButton
                                                                className={classes.smaller}
                                                                onClick={(e) => {
                                                                    if (row) {
                                                                        var supplierProId = row.original.supplierProfileId;

                                                                        this.setState({ active: true });

                                                                        confirmAlert({
                                                                            title: 'Confirm to Activate',
                                                                            message: 'Are you sure to do this.',
                                                                            buttons: [
                                                                                {
                                                                                    label: 'Yes',
                                                                                    onClick: () => this.onActive(supplierProId)
                                                                                },
                                                                                {
                                                                                    label: 'No'
                                                                                }
                                                                            ]
                                                                        })
                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-red">cancel</Icon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                )
                                            )
                                        }

                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>

                    }
                />

            )
        }
    }

}

export default withStyles(styles, { withTheme: true })(withAlert(Supplier));










// WEBPACK FOOTER //
// ./src/main/content/inventory/supplier/AllSupplier.js